<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      fill="currentColor"
      d="M6.33335 5.44444C5.84243 5.44444 5.44446 5.84241 5.44446 6.33333V17.6667C5.44446 18.1576 5.84243 18.5556 6.33335 18.5556H17.6667C18.1576 18.5556 18.5556 18.1576 18.5556 17.6667V12.8889H20.5556V17.6667C20.5556 19.2622 19.2622 20.5556 17.6667 20.5556H6.33335C4.73786 20.5556 3.44446 19.2622 3.44446 17.6667V6.33333C3.44446 4.73784 4.73786 3.44444 6.33335 3.44444H11.1111V5.44444H6.33335Z"
    />
    <path
      fill="currentColor"
      d="M18.5556 6.83183V11.1111H20.5556V4.63333C20.5556 3.97673 20.0233 3.44444 19.3667 3.44444L12.8889 3.44444V5.44444L17.11 5.44444L10.3771 11.6634C9.97137 12.0381 9.94626 12.6707 10.321 13.0765C10.6957 13.4822 11.3284 13.5073 11.7341 13.1325L18.5556 6.83183Z"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
